import compose from 'react-hooks-compose'

import { useLogic } from './useLogic'
import { Presenter } from './presenter'

export const InputSelect = compose(props => ({
	useLogic: () => useLogic(props),
}))(Presenter)
